// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsSetTeamFollowBody = {
  teamId: string;
  isFollowing: boolean;
};

export type typeNotificationSettingsSetTeamFollowOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teamId: string;
    isFollowing: boolean;
    isFirstFollow: boolean;
  };
};

export type typeNotificationSettingsSetTeamFollowOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetTeamFollowOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetTeamFollowOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsSetTeamFollowBody = {
  type: "object",
  properties: {
    teamId: { type: "string", maxLength: 3000, minLength: 1 },
    isFollowing: { type: "boolean" },
  },
  required: ["teamId", "isFollowing"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsSetTeamFollow(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(
      schemaNotificationSettingsSetTeamFollowBody,
    );
  }

  return async function postNotificationSettingsSetTeamFollow(
    payload: typeNotificationSettingsSetTeamFollowBody,
  ): Promise<
    | typeNotificationSettingsSetTeamFollowOutput200
    | typeNotificationSettingsSetTeamFollowOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsSetTeamFollow" failed before calling the network. #e2dd0f98ec74`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e2dd0f98ec74" },
        },
        data: null,
      } as typeNotificationSettingsSetTeamFollowOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/set-team-follow`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsSetTeamFollowOutput200
      | typeNotificationSettingsSetTeamFollowOutput400;
  };
}
